import { useMemo } from "react";
import { useGeotabClient } from "@/components/GeotabClientContext";
import { GEOTAB_GROUP_NAMES } from "@/constants/groupConfig";
import { GroupIndex, groupAncestry } from "@/utilities/groupIndex";
import { userGroupIds } from "@/utilities/user/userGroupIds";

/**
 * Driver and reason may only be changed by members of the "FairfleetLogbookEdit" group, the
 * same group that unlocks the Fahrtenbuch page. Membership counts through the user's
 * data-access groups and report groups, and as everywhere in Geotab a user in one of the
 * group's parents (up to the company root) is a member too. The customs auditors sit in the
 * sibling group "FairfleetLogbookAudit" and stay read-only. The group comes from the page's
 * group index, so no extra request is needed.
 */
export function useCanEditTrips(groupIndex: GroupIndex): boolean {
  const { me } = useGeotabClient();
  return useMemo(() => {
    const memberOf = userGroupIds(me);
    if (memberOf.length === 0) return false;
    const group = [...groupIndex.byId.values()].find(g => g.name === GEOTAB_GROUP_NAMES.LOGBOOKEDIT);
    if (!group) return false;
    const allowed = new Set(groupAncestry(group.id, groupIndex).map(g => g.id));
    return memberOf.some(id => allowed.has(id));
  }, [me, groupIndex]);
}
